import { CSSProperties } from 'react';
import tinycolor from 'tinycolor2';
import { Color, Size, Styles } from '@vivli/shared/theme';

const innerContainerStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    ...Styles.Transition.HOVER_OPACITY_TRANSITION,
};

interface VerticalNavTabProps {
    title: string;
    url: string;
    active: boolean;
    onTabClick: () => void;
    isDisabled?: boolean;
    isLoading?: boolean;
}

export const VerticalNavTabView = ({ title, active = false, onTabClick, isDisabled, isLoading }: VerticalNavTabProps) => {
    const tabContainerStyle: CSSProperties = {
        ...Styles.NO_SELECT,
        marginBottom: 0,
        alignItems: 'center',
        paddingLeft: Size.PADDING,
        fontSize: Size.FontSize.Large,
        backgroundColor: active ? 'rgb(233, 234, 239)' : Color.WHITE,
        cursor: isLoading ? 'wait' : isDisabled ? 'not-allowed' : 'pointer',
        pointerEvents: 'inherit',
        position: 'relative',
        zIndex: active ? 0 : 12,
        borderBottom: '1px solid rgba(233, 234, 239, 0.5)',
    };

    const textStyle: CSSProperties = {
        color:
            isDisabled || isLoading
                ? Color.VIVLI_GREY
                : active
                ? Color.TEXT_DARK_BLUE
                : tinycolor(Color.TEXT_DARK_BLUE).clone().lighten(20).toRgbString(),
        fontWeight: active ? Size.FontWeight.Bold : Size.FontWeight.Regular,
    };

    return (
        <div style={tabContainerStyle} onClick={onTabClick} data-test-id={title?.replace(' ', '_')?.toLowerCase()}>
            <div style={innerContainerStyle}>
                <span style={textStyle}>{title}</span>
            </div>
        </div>
    );
};
